module.exports = __webpack_public_path__ + "assets/img/costs_p_img.8e25c3e9.png";